import { Box, Typography, Alert, Button } from '@mui/material';
import { designTokens } from '../theme/theme';

export const SandboxBanner = ({startTutorial, role}: {startTutorial: () => void, role: 'peer' | 'facilitator' | 'editor' | 'admin'}) => {

  const handleStartTutorial = (): void => {
    startTutorial();
  };

  return (
    <Alert 
      severity="info"
      sx={{
        '& .MuiAlert-message': { 
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        },
      }}
    >
      <Box>
        <Typography variant="body1" component="span" sx={{ fontWeight: 'bold' }}>
          🏖️ Sandbox Mode Active
        </Typography>
        {(role === 'peer' || role === 'facilitator') && (
          <Typography variant="body2" component="div" sx={{ mt: 0.5 }}>
            You're in a safe tutorial environment. All changes are saved locally and won't affect real data.
          </Typography>
        )}
        {(role === 'editor' || role === 'admin') && (
          <Typography variant="body2" component="div" sx={{ mt: 0.5 }}>
            You're in a tutorial environment, but due to your role, all changes you make ARE real.
          </Typography>
        )}
      </Box>
      {(role === 'facilitator' || role === 'admin' || role === 'editor') && (
      <Button 
        variant="outlined" 
        size="small" 
        onClick={handleStartTutorial}
        sx={{ ml: 2, flexShrink: 0 }}
      >
        Start Tutorial
      </Button>
      )}
    </Alert>
  );
};
